import { User, UserType } from "../lib/user";
import { apiClient } from "../lib/createApiClient";
import { email, cf } from "../lib/validators";
//import { Pratica, StatiPratica } from "../types";

type TODO = any[];

const form: TODO = [
  //DATI BENEFICIARIO
  {
    name: "Beneficiario",
    fields: [
      //CODICE FISCALE
      {
        name: "Codice fiscale",
        id: "codice-fiscale",
        validate: cf,
        onChange: (
          value: string,
          setField: (id: string, val: string | number | null) => void
        ) => {
          const fieldsToCompile = [
            "cognome",
            "nome",
            "email",
            "telefono",
            "cf-fronte",
            "cf-retro",
            "cid-fronte",
            "cid-retro",
            "address",
            "comunicazione-sconto-fattura",
            "copia-fattura-mw",
            "ricevuta-protocollo-ade",
          ];
          if (value && value.length === 16)
            apiClient.get(`/search/cf/?id=${value}`).then((fields: any) => {
              if (fields) {
                Object.keys(fields).forEach((name) =>
                  setField(name, fields[name])
                );
                setTimeout(() => {
                  setField("situazione-cliente", "1");
                }, 100);
              } else fieldsToCompile.forEach((name) => setField(name, ""));
            });
        },
      },
      //SCANSIONE CODICE FISCALE
      {
        name: "Scansione codice fiscale",
        desc:
          "Se la scansione del codice fiscale contiene sia il fronte che il retro del documento è consentito ignorare il campo 'Retro'",
        type: "group",
        id: "_cf-group",
        fields: [
          {
            type: "row",
            items: 2,
            fields: [
              {
                name: "Fronte",
                id: "cf-fronte",
                type: "file",
                required: true,
                delegabile: true,
              },
              {
                name: "Retro",
                id: "cf-retro",
                type: "file",
                delegabile: true,
              },
            ],
          },
        ],
      },
      //COGNOME
      {
        name: "Cognome",
        id: "cognome",
        required: true,
      },
      //NOME
      {
        name: "Nome",
        id: "nome",
        required: true,
      },
      //EMAIL
      {
        name: "Email",
        id: "email",
        validate: email,
        required: true,
      },
      //TELEFONO
      {
        name: "Telefono",
        id: "telefono",
        required: true,
      },
      //INDIRIZZO
      {
        name: "Indirizzo",
        id: "address",
        desc: "eg. Via Fulvio Testi 32, 20100, Milano (MI)",
        required: true,
      },
      //CARTA IDENTITA
      {
        name: "Carta Identità",
        type: "group",
        id: "_ci-group",
        desc:
          "Se la scansione della carta d'identità contiene sia il fronte che il retro del documento è consentito ignorare il campo 'Retro'",
        fields: [
          {
            type: "row",
            items: 2,
            fields: [
              {
                name: "Fronte",
                id: "cid-fronte",
                type: "file",
                required: true,
                delegabile: true,
              },
              {
                name: "Retro",
                id: "cid-retro",
                type: "file",
                delegabile: true,
              },
            ],
          },
        ],
      },
    ],
  },
  //PRODOTTI
  {
    name: "Dati prodotti e servizi*",
    fields: [
      //PRODOTTI
      {
        type: "multiple",
        btnLabel: "Aggiungi prodotto o servizio",
        id: "nuovo-prodotto-mobili",
        list: "MW_productList_mobili",
        required: true,
        // onChange: (
        //   value: any,
        //   setField: (id: string, val: string | number | null) => void
        // ) => {
        //   console.log(value, setField);
        // },
      },
    ],
  },
  //RIEPILOGO TOTALI
  {
    name: "Riepilogo totali prodotti",
    fields: [
      //PERCENTUALE CREDITO IMPOSTA
      {
        type: "radio-group",
        name: "Percentuale credito d'imposta",
        id: "ecobonus-type",
        initialValue: "0",
        options: [
          {
            name: "50%",
            value: "0",
            default: true,
          },
        ],
      },
      //TOTALE AGEVOLATI
      {
        name: "Totale prodotti agevolati",
        id: "prezzo-totale",
        readonly: true,
      },
      //TOTALE NON AGEVOLATI
      {
        name: "Totale prodotti senza agevolazione",
        id: "prezzo-totale-no-bonus",
        readonly: true,
      },
      //TOTALE AQUIRENTE
      {
        name: "Totale pagamento riservato all'acquirente",
        id: "totale-pagamento",
        desc:
          "Totale prodotti/servizi agevolati + totale prodotti/servizi senza agevolazione",
        readonly: true,
      },
      //CREDITO IMPOSTA
      {
        name: "Credito d'imposta",
        id: "credito-imposta",
        readonly: true,
      },
    ],
  },

  //DOCUMENTI SPECIFICI PER TIPOLOGIA
  {
    name: "Documenti riservati al cliente",
    fields: [
      //DICHIARAZIONE BONUS MOBILI
      {
        type: "file",
        name: "Dichiarazione bonus mobili",
        id: "dichiarazione-mw-bonus-mobili",
        required: true,
        delegabile: true,
        fac_simile: `/docs/dichiarazione-mediaworld-bonus-mobili.pdf`,
      },
      //EDILIZIA LIBERA ASSENZA TITOLO ABILITATIVO
      // {
      //   type: "file",
      //   name:
      //     "Titolo abilitativo (CILA SCIA etc) o in assenza, dichiarazione sostitutiva di intervento in edilizia libera",
      //   id: "edilizia-libera-titolo-abilitativo",
      //   required: true,
      //   delegabile: true,
      //   fac_simile: `/docs/edilizia-libera-assenza-titolo-abilitativo.pdf`,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] !== "3",
      // },
      // {
      //   type: "file",
      //   name:
      //     "Titolo abilitativo (CILA SCIA etc) con relativo protocollo di avvenuta comunicazione al Comune prima dell'inizio dei lavori di ristrutturazione",
      //   id: "edilizia-libera-titolo-abilitativo",
      //   required: true,
      //   delegabile: true,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] === "3",
      // },
      // //COMUNICAZIONE SCONTO IN FATTURA
      // {
      //   type: "file",
      //   name:
      //     "Copia Comunicazione dell'opzione per lo sconto in fattura con anno di sostenimento della spesa 2022",
      //   id: "comunicazione-sconto-fattura",
      //   required: true,
      //   delegabile: true,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] !== "3",
      // },
      // //RICEVUTA PROTOCOLLO
      // {
      //   type: "file",
      //   name:
      //     "Copia relativa ricevuta di protocollo di avvenuta presentazione telematica all'Agenzia delle Entrate",
      //   id: "ricevuta-protocollo-ade",
      //   required: true,
      //   delegabile: true,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] !== "3",
      // },
      // // COPIA FATTURA MW
      // {
      //   type: "multiple",
      //   fnEditable: () => false,
      //   btnLabel: "Nuova fattura/spesa",
      //   list: "copiaFatturaList",
      //   id: "copia-fattura-mw",
      //   required: true,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] === "1",
      // },
      // //FATTURA ALTRO FORNITORE
      // {
      //   type: "file",
      //   name:
      //     "Copia Fattura dell'acquisto effettuato presso altro fornitore nel 2022",
      //   id: "copia-fattura-no-mw",
      //   required: true,
      //   delegabile: true,
      //   if: (values: Record<string, any>) =>
      //     values["situazione-cliente"] === "2",
      // },
    ],
  },
  //TIPOLOGIA CLIENTE
  {
    name: "Situazione cliente",
    fields: [
      {
        type: "radio-group",
        name:
          "Quale delle seguenti casistiche rispecchia la situazione del cliente?",
        id: "situazione-cliente",
        initialValue: "1",
        items: 1,
        options: [
          //CON SCONTO MEDIAWORLD
          {
            name:
              "Cliente con sconto in fattura/cessione del credito per acquisto 2022 presso punto vendita MEDIAWORLD",
            value: "1",
            default: true,
          },
          //CON SCONTO ALTRO FORNITORE
          {
            name:
              "Cliente con sconto in fattura/cessione del credito per acquisto 2022 presso ALTRO FONITORE in edilizia libera",
            value: "2",
          },
          //RECUPERO PATRIMONIO EDILIZIO
          {
            name:
              "Cliente con lavori di recupero del patrimonio edilizio iniziati a decorrere dal 1° Gennaio 2022",
            value: "3",
          },
        ],
        required: true,
      },
    ],
  },
  // DOCUMENTI BONUS CONDIZIONATORI MEDIAWORLD
  {
    name: "DOCUMENTI BONUS CONDIZIONATORI MEDIAWORLD",
    if: (values: Record<string, any>) => {
      return values["situazione-cliente"] === "1";
    },
    fields: [
      {
        type: "file",
        name:
          "Titolo abilitativo (CILA SCIA etc) o in assenza, dichiarazione sostitutiva di intervento in edilizia libera",
        id: "edilizia-libera-titolo-abilitativo",
        required: true,
        delegabile: true,
        fac_simile: `/docs/edilizia-libera-assenza-titolo-abilitativo.pdf`,
      },
      {
        type: "file",
        name:
          "Copia Comunicazione dell'opzione per lo sconto in fattura con anno di sostenimento della spesa 2022",
        id: "comunicazione-sconto-fattura",
        required: true,
        delegabile: true,
      },
      {
        type: "file",
        name:
          "Copia relativa ricevuta di protocollo di avvenuta presentazione telematica all'Agenzia delle Entrate",
        id: "ricevuta-protocollo-ade",
        required: true,
        delegabile: true,
      },
      {
        type: "multiple",
        fnEditable: () => false,
        btnLabel: "Nuova fattura/spesa",
        list: "copiaFatturaList",
        id: "copia-fattura-mw",
        required: true,
      },
    ],
  },
  //DOCUMENTI BONUS CONDIZIONATORI ALTRO FORNITORE
  {
    name: "DOCUMENTI BONUS CONDIZIONATORI ALTRO FORNITORE",
    if: (values: Record<string, any>) => {
      return values["situazione-cliente"] === "2";
    },
    fields: [
      {
        type: "file",
        name:
          "Titolo abilitativo (CILA SCIA etc) o in assenza, dichiarazione sostitutiva di intervento in edilizia libera",
        id: "edilizia-libera-titolo-abilitativo-no-mw",
        required: true,
        delegabile: true,
        fac_simile: `/docs/edilizia-libera-assenza-titolo-abilitativo.pdf`,
      },
      {
        type: "file",
        name:
          "Copia Comunicazione dell'opzione per lo sconto in fattura con anno di sostenimento della spesa 2022",
        id: "comunicazione-sconto-fattura-no-mw",
        required: true,
        delegabile: true,
      },
      {
        type: "file",
        name:
          "Copia relativa ricevuta di protocollo di avvenuta presentazione telematica all'Agenzia delle Entrate",
        id: "ricevuta-protocollo-ade-no-mw",
        required: true,
        delegabile: true,
      },
      {
        type: "file",
        name:
          "Copia Fattura dell'acquisto effettuato presso altro fornitore nel 2022",
        id: "copia-fattura-no-mw",
        required: true,
        delegabile: true,
      },
    ],
  },
  // DOCUMENTI EDILIZIA LIBERA 2022
  {
    name: "DOCUMENTI EDILIZIA LIBERA 2022",
    if: (values: Record<string, any>) => {
      return values["situazione-cliente"] === "3";
    },
    fields: [
      {
        type: "file",
        name:
          "Titolo abilitativo (CILA SCIA etc) con relativo protocollo di avvenuta comunicazione al Comune prima dell'inizio dei lavori di ristrutturazione",
        id: "edilizia-libera-titolo-abilitativo-2022",
        required: true,
        delegabile: true,
      },
    ],
  },
  //FATTURE
  {
    name: "Fatture e spese emesse al cliente*",
    fields: [
      {
        type: "multiple",
        btnLabel: "Nuova fattura/spesa",
        list: "fatturaList",
        id: "fattura-e-spese",
        required: true,
      },
    ],
  },
  //ALTRI FILES
  {
    name: "Altri documenti",
    fields: [
      {
        type: "multiple",
        btnLabel: "Allega documento",
        list: "otherFilesList",
        id: "other-files-list",
      },
    ],
  },
  //ASSEVERATORE TECNICO
  {
    name: "Documenti riservati all'asseveratore",
    if: (values: Record<string, any>, user: User) => {
      return user.type >= UserType.Asseveratore;
    },
    fields: [
      {
        name: "Pratica ENEA",
        id: "file-pratiche-ENEA",
        type: "file",
        fnEditable: (values: Record<string, any>, user: User) => {
          return user.type >= UserType.Asseveratore;
        },
      },
      {
        name: "Ricevuta pratica ENEA",
        id: "ricevuta-file-pratiche-ENEA",
        type: "file",
        fnEditable: (values: Record<string, any>, user: User) => {
          return user.type >= UserType.Asseveratore;
        },
      },
    ],
  },
];

export default form;
